module.exports = new __parcel__URL__("3.cb3cc22f.webp").toString();